<template>
  <AdminLayout page="Admin Home" title="Home">
    <div v-if="isPropertyLoading"><Loading /></div>
    <div v-else>
      <BackButton :to="`/${bldgStore.siteCode}`"> Back to Training Site </BackButton>
      <div class="flex flex-wrap gap-4 justify-center mt-16">
        <router-link
          v-if="hasPermission(PermissionType.SendAlerts)"
          class="w-48 md:h-48 sm:h-16"
          to="admin/alert"
        >
          <BaseButton
            class="w-full h-full text-center bg-red-200 hover:bg-red-600"
            :icon-only="false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6 m-auto align-bottom"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46"
              />
            </svg>
            Alert
          </BaseButton>
        </router-link>

        <router-link
          v-if="hasPermission(PermissionType.EditContacts)"
          class="w-48 md:h-48 sm:h-16"
          to="admin/contacts"
        >
          <BaseButton class="w-full h-full text-center" :icon-only="false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6 m-auto align-bottom"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
              />
            </svg>
            Contacts
          </BaseButton>
        </router-link>

        <router-link
          v-if="hasPermission(PermissionType.EditDocuments)"
          class="w-48 md:h-48 sm:h-16"
          to="admin/docs"
        >
          <BaseButton class="w-full h-full text-center" :icon-only="false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6 m-auto align-bottom"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
              />
            </svg>
            Documents
          </BaseButton>
        </router-link>

        <router-link
          v-if="hasPermission(PermissionType.EditRespond)"
          class="w-48 md:h-48 sm:h-16"
          to="admin/respond"
        >
          <BaseButton class="w-full h-full text-center" :icon-only="false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6 m-auto align-bottom"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 6.878V6a2.25 2.25 0 0 1 2.25-2.25h7.5A2.25 2.25 0 0 1 18 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 0 0 4.5 9v.878m13.5-3A2.25 2.25 0 0 1 19.5 9v.878m0 0a2.246 2.246 0 0 0-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0 1 21 12v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6c0-.98.626-1.813 1.5-2.122"
              />
            </svg>
            Respond
          </BaseButton>
        </router-link>

        <router-link
          v-if="hasPermission(PermissionType.EditTenant)"
          class="w-48 md:h-48 sm:h-16"
          to="admin/tenants"
        >
          <BaseButton class="w-full h-full text-center" :icon-only="false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6 m-auto align-bottom"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"
              />
            </svg>
            Tenants
          </BaseButton>
        </router-link>

        <router-link
          v-if="hasPermission(PermissionType.ViewUsers)"
          class="w-48 md:h-48 sm:h-16"
          to="admin/users"
        >
          <BaseButton class="w-full h-full text-center" :icon-only="false">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="size-6 m-auto align-bottom"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
              />
            </svg>
            Users
          </BaseButton>
        </router-link>
      </div>
      <h1
        v-if="
          hasAnyPermissions([
            PermissionType.ViewTrainingReport,
            PermissionType.ViewPortalRoster,
            PermissionType.ViewMobilityReport,
            PermissionType.ViewVRReport,
            PermissionType.ViewVRFilterReport,
            PermissionType.ViewAlertSubscriptions,
            PermissionType.ViewTenantContactReport,
          ])
        "
        class="text-xl mt-16 font-medium"
      >
        Reports
      </h1>
      <div class="flex flex-col ml-2 mt-4">
        <router-link
          v-if="hasPermission(PermissionType.ViewTrainingReport)"
          class="w-64 mb-4"
          to="admin/trainingreport"
        >
          <BaseButton class="w-full" :icon-only="false">Training Report</BaseButton>
        </router-link>
        <router-link
          v-if="hasPermission(PermissionType.ViewPortalRoster)"
          class="w-64 mb-4"
          to="admin/propertyrosterreport"
        >
          <BaseButton class="w-full" :icon-only="false">
            {{ user?.isTenantAdmin ? "Tenant" : "Property" }} Roster Report
          </BaseButton>
        </router-link>
        <router-link
          v-if="hasPermission(PermissionType.ViewMobilityReport)"
          class="w-64 mb-4"
          to="admin/mobilityreport"
        >
          <BaseButton class="w-full" :icon-only="false">Mobility Report</BaseButton>
        </router-link>
        <router-link
          v-if="isVREnabled && hasPermission(PermissionType.ViewVRReport)"
          class="w-64 mb-4"
          to="admin/vrreport"
        >
          <BaseButton class="w-full" :icon-only="false">VR Report</BaseButton>
        </router-link>
        <router-link
          v-if="isVREnabled && hasPermission(PermissionType.ViewVRFilterReport)"
          class="w-64 mb-4"
          to="admin/vrfilterreport"
        >
          <BaseButton class="w-full" :icon-only="false">VR Filter Report</BaseButton>
        </router-link>
        <router-link
          v-if="isAlertEnabled && hasPermission(PermissionType.ViewAlertSubscriptions)"
          class="w-64 mb-4"
          to="admin/alert/subscriptions"
        >
          <BaseButton class="w-full" :icon-only="false">Alert Subscriptions</BaseButton>
        </router-link>
        <router-link
          v-if="hasPermission(PermissionType.ViewTenantContactReport)"
          class="w-64 mb-4"
          to="admin/tenantcontactreport"
        >
          <BaseButton class="w-full" :icon-only="false">Tenant Contact Report</BaseButton>
        </router-link>
      </div>
    </div>
  </AdminLayout>
</template>

<script setup lang="ts">
import { useBldgStore } from "../../store/bldgStore";
import { useUserStore } from "../../store/userStore";
import { PermissionType } from "../../store/generatedFetchClient";

const bldgStore = useBldgStore();
const userStore = useUserStore();
const hasPermission = userStore.hasPermission;
const hasAnyPermissions = userStore.hasAnyPermission;

var isPropertyLoading = computed(() => bldgStore.isLoading);
var user = computed(() => userStore.user);
var isVREnabled = computed(() => bldgStore.building?.isVrtourEnabled);
var isAlertEnabled = computed(() => bldgStore.building?.isAlertEnabled);
</script>
